<template>
  <div v-if="false"></div>
</template>

<script>
  export default {
    name: "vf-dialog-item"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// vf-dialog-item.vue?21044df4